export const PUSH_TOAST = "PUSH_TOAST";
export const DELETE_TOAST = 'DELETE_TOAST';
export const POP_TOAST = 'POP_TOAST';
export const FLUSH_TOAST = 'FLUSH_TOAST';

export interface ToastData {
  toastList : any[]
}

type ToastAction = typeof PUSH_TOAST | typeof DELETE_TOAST | typeof POP_TOAST | typeof FLUSH_TOAST;

export interface ToastPayload {
  type: ToastAction
  data: any;
}